import React from 'react';
import { Edit, useEditContext, useTranslate } from 'react-admin';
import Form from './detail/Form';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const Title = () => {
  const { record, isPending } = useEditContext();
  const translate = useTranslate();
  const name = !isPending && record ? record.fullname : null;
  const action = translate('app.page_title.edit');
  useDocumentTitle(name ? `${name} - ${action}` : action);

  return <span>Modifier {isPending ? '' : `${record?.fullname}`}</span>;
};

const CleanerEdit = (props) => {
  return (
    <Edit {...props} title={<Title />}>
      <Form />
    </Edit>
  );
};

export default CleanerEdit;
